import { useEffect } from "react";
import { TABLET_WIDTH } from "@/common/utils/device";
import { useMediaQuery } from "usehooks-ts";

export const useMobPosition = (updateFunc: () => void) => {
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);

  useEffect(() => {
    if (isDesktop) {
      return;
    }

    const handleScroll = () => {
      updateFunc();
    };

    document.addEventListener("scroll", handleScroll, true);

    return () => {
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, [updateFunc, isDesktop]);
};
